import Vue from "vue";
import VueCookies from "vue-cookies";
import axios from "axios";
import moment from "moment";
import { Loading } from "element-ui";
import store from "../store";
import router from "../router";

// timezone setting change ** require
Date.prototype.toISOString = function () {
  return moment(this).format();
};
Date.prototype.toJSON = function () {
  return moment(this).format("YYYY-MM-DD[T]HH:mm:ss");
};

//var csrfToken = $("meta[name='_csrf']").attr("content");
//var csrfHeader = $("meta[name='_csrf_header']").attr("content");
//if (csrfToken != undefined && csrfHeader != undefined && csrfToken != '' && csrfHeader != '') {
//    axios.defaults.headers.post[csrfHeader] = csrfToken;
//}

const ax = axios.create({
  headers: {
    post: {
      "Content-Type": "application/json;charset=UTF-8",
      "X-Requested-With": "XMLHttpRequest",
    },
    get: {
      "Content-Type": "application/json;charset=UTF-8",
      "X-Requested-With": "XMLHttpRequest",
    },
  },
  withCredentials: true,
});

//ax.defaults.timeout = 2500;

let loadingInstance = null;
var visibleLoading = true;
ax.interceptors.request.use(
  (config) => {
    if (store.getters.currentUser != null && store.getters.currentUser.ssnId != null) {
      ax.defaults.headers.common["X-Auth-Token"] = store.getters.currentUser.ssnId;
      // console.log("store.getters.currentUser.ssnId", store.getters.currentUser.ssnId);
    }

    if (visibleLoading) {
      loadingInstance = Loading.service({ background: "rgb(254 255 255 / 19%)", lock: true, fullscreen: true });
      document.body.style.cursor = "wait";
    }
    return config;
  },
  (error) => {
    if (loadingInstance != null) loadingInstance.close();
    document.body.style.cursor = "default";
    return Promise.reject(error);
  }
);

ax.interceptors.response.use(
  (response) => {
    if (loadingInstance != null) loadingInstance.close();
    document.body.style.cursor = "default";

    if (response.headers["isauthenticated"] != null && response.headers["isauthenticated"] == "false" && store.getters.currentUser != null) {
      // console.log('store.commit("setLogout");');
      //store.dispatch("setLogout");
      if (router.history?.current.meta.requiresAuth != null) {
        //alert("router.history?.current.meta.requiresAuth : " + router.history?.current.meta.requiresAuth);
        router.push({ path: "/usr/login" }).catch();
      }
    }

    return response;
  },
  (error) => {
    if (loadingInstance != null) loadingInstance.close();
    document.body.style.cursor = "default";

    console.log(error.response);
    const statusCode = error.response?.status;
    if (statusCode == 401) {
      store.dispatch("setLogout");
      router.push({ path: "/usr/login" }).catch();
      // console.log("redirect login");
    }

    return error;
  }
);

export const { hostname } =
  process.env.NODE_ENV === "production"
    ? {
        hostname: "",
      }
    : {
        hostname: "http://" + location.hostname + ":8881",
      };

export const assetsURL = `${hostname}/assets`;
export const apiURL = `${hostname}/api`;
export const siteURL = `${hostname}`;

Vue.prototype.request = function (url, param) {
  visibleLoading = false;
  if (store.getters.currentUser != null && store.getters.currentUser.ssnId != null) {
    ax.defaults.headers.common["X-Auth-Token"] = store.getters.currentUser.ssnId;
    // console.log("store.getters.currentUser.ssnId", store.getters.currentUser.ssnId);
  }

  var params = "";
  if (param != null && typeof param != "string") {
    Object.keys(param).map(function (k, v) {
      if (param[k] != undefined && typeof param[k] != "object" && typeof param[k] != "function") {
        params += "&" + k + "=" + encodeURIComponent(param[k]);
      } else if (param[k] != undefined && typeof param[k].getMonth == "function") {
        params += "&" + k + "=" + moment(param[k]).format("YYYY-MM-DDTHH:mm");
      }
    });
  } else {
    params = param != undefined ? param : "";
  }

  if (params != "") {
    url = url + (url.indexOf("?") > -1 ? "&" + params : "?" + params);
  }

  return ax.get(url);
};

Vue.prototype.submit = function (url, data, loading, headers) {
  if (store.getters.currentUser != null && store.getters.currentUser.ssnId != null) {
    ax.defaults.headers.common["X-Auth-Token"] = store.getters.currentUser.ssnId;
    // console.log("store.getters.currentUser.ssnId", store.getters.currentUser.ssnId);
  }

  var self = this;
  visibleLoading = loading != null ? loading : true;

  var fileCount = 0;
  var isSubmit = false;
  if (this.$children != null) {
    for (let idx in this.$children) {
      var children = this.$children[idx];
      if (children.$refs.input != null && children.$refs.input.uploadFiles != null) {
        var upload = children.$refs.input;
        for (let f in upload.uploadFiles) {
          if (upload.uploadFiles[f].status != "uploaded" && upload.uploadFiles[f].status != "success") {
            fileCount++;
            break;
          }
        }
      }
    }
  }

  return commandSubmit();

  function commandSubmit() {
    return new Promise((resolve, reject) => {
      if (fileCount > 0) {
        self.$root.$off("fileUploadComplete");
        self.$root.$on("fileUploadComplete", function (file) {
          fileCount--;
          console.log("fileCount", fileCount);
          if (fileCount <= 0 && !isSubmit) {
            isSubmit = true;
            submitPost(url, data);
          }
        });

        for (let idx in self.$children) {
          var children = self.$children[idx];
          if (children.$refs.input != null && children.$refs.input.uploadFiles != null) {
            var upload = children.$refs.input;
            for (let f in upload.uploadFiles) {
              if (upload.uploadFiles[f].status != "uploaded" && upload.uploadFiles[f].status != "success") {
                upload.submit();
              }
            }
          }
        }
      } else {
        submitPost(url, data);
      }

      function submitPost(url, result) {
        return ax
          .post(url, result, {
            headers: headers,
          })
          .then((response) => {
            // console.log("response", response);
            if (response.status == 200 && response.data.status != "FAIL") {
              if (self.$children != null) {
                for (let idx in self.$children) {
                  var children = self.$children[idx];
                  if (children.$refs.input != null && children.$refs.input.uploadFiles != null) {
                    var upload = children.$refs.input;
                    for (let f in upload.uploadFiles) {
                      if (upload.uploadFiles[f].status != "uploaded" && upload.uploadFiles[f].status != "success") {
                        upload.$emit("input", upload.valueOrg);
                        // console.log("upload emit ", upload);
                      }
                    }
                  }
                }
              }
            }

            resolve(response);
          })
          .catch((e) => {
            Vue.prototype.$alert("오류가 발생되어 요청 작업이 처리되지 않았습니다.");
            reject(e);
          });
      }
    });
  }
};

Vue.prototype.isMobile = function () {
  if (/Macintosh/.test(navigator.userAgent) && "ontouchend" in document) {
    return true;
  }

  return /khsaeduapp|Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
};

Vue.prototype.isApp = function () {
  return navigator.userAgent.indexOf("khsaeduapp") > -1;
};
Vue.prototype.isIOSApp = function () {
  return navigator.userAgent.indexOf("khsaeduapp") > -1 && /iPhone|iPad|iPod/i.test(navigator.userAgent);
};

Vue.prototype.loader = function (action, element, text) {
  if (this.$root.loading == undefined && action == "close") {
    return;
  }
  if (action != null && action == "close") {
    this.$root.loading.close();
    this.$root.loading = null;
    return;
  }

  this.$root.loading = null;
  this.$root.loading = this.$root.$loading({
    target: element ? element : "body",
    lock: true,
    fullscreen: element ? false : true,
    text: text || "",
    spinner: "el-icon-loading",
    background: "rgb(254 255 255 / 19%)",
  });
  // console.log(this.$root.loading);

  if (action != "infinity") {
    setTimeout(() => {
      if (this.$root.loading != null) this.$root.loading.close();
    }, 120000);
  }
};

Vue.prototype.smload = function (element, action) {
  // console.log("===========");
  // console.log(this.$root.loading2);

  if (this.$root.loading2 == undefined && action == "close") {
    return;
  }
  if (action != null && action == "close") {
    this.$root.loading2.close();
    return;
  }

  this.$root.loading2 = this.$root.$loading({
    target: "div",
    lock: true,
    fullscreen: true,
    text: "Loading",
    spinner: "el-icon-loading",
    background: "rgb(254 255 255 / 19%)",
  });
  // console.log(this.$root.loading);

  setTimeout(() => {
    this.$root.loading2.close();
  }, 120000);
};

Vue.prototype.responseResult = function (res, isSuccess) {
  var response = res || {};
  if (response.status == null || response.status == undefined) {
    Vue.prototype.$alert("오류가 발생되어 요청 작업이 처리되지 않았습니다.", "안내", {
      confirmButtonText: "확인",
      dangerouslyUseHTMLString: true,
      callback: (action) => {
        if (this.$root.loading != null) this.$root.loading.close();
      },
    });
  } else if (response.status != "FAIL" && !isSuccess) {
    return true;
  } else if (response.status != "FAIL") {
    this.$notify({
      title: "Success",
      type: "success",
      message: response.result,
      dangerouslyUseHTMLString: true,
      duration: 3000,
      onClose: () => {
        if (this.$root.loading != null) this.$root.loading.close();
      },
    });

    return true;
  } else {
    let messages = "";
    if (typeof response.result == "object") {
      response.result.forEach((collection) => {
        messages += collection.message;
        messages += "<br>";
      });

      Vue.prototype.$alert(messages, "안내", {
        confirmButtonText: "확인",
        dangerouslyUseHTMLString: true,
        callback: (action) => {
          if (this.$root.loading != null) this.$root.loading.close();
        },
      });
    } else {
      if (response.result.startsWith("500")) {
        messages = "오류가 발생하여 데이터를 가져오지 못했습니다.\n관리자에게 문의 하시기 바랍니다.";
      } else if (response.result.startsWith("503")) {
        messages = "서비스가 활성화 되어 있지 않습니다.\n관리자에게 문의 하시기 바랍니다.";
      } else if (response.result.startsWith("401")) {
        messages = "로그인 후 이용해 주세요.";
      } else {
        messages = response.result;
      }

      Vue.prototype.$alert(messages, "안내", {
        confirmButtonText: "확인",
        callback: (action) => {
          if (this.$root.loading != null) this.$root.loading.close();
        },
      });
    }
    return false;
  }
};

Vue.prototype.requestForm = function (url, data, target) {
  let param = "";
  let result = Object.assign({}, data);

  $("#submitForm").remove();
  var $form = $('<form id="submitForm"></form>');
  if (result != undefined && result != null) {
    Object.keys(result).map(function (k, v) {
      if (result[k] != undefined && typeof result[k] != "object" && typeof result[k] != "function") {
        $form.append('<input type="hidden" name="' + k + '" value="' + result[k] + '" />');
      } else if (result[k] != undefined && typeof result[k].getMonth == "function") {
        $form.append('<input type="hidden" name="' + k + '" value="' + moment(result[k]).format("YYYY-MM-DDTHH:mm") + '" />');
      }
      if (result[k] != undefined && typeof result[k] == "object") {
        Object.keys(result[k]).map(function (i) {
          $form.append('<input type="hidden" name="' + i + '" value="' + result[k][i] + '" />');
        });
      }
    });
  }

  $("body").append($form);
  if (target != null) {
    $("#submitForm").attr("target", target);
  }
  $("#submitForm").attr("method", "post").attr("action", url).submit();
};
